export default () => ({
    filterActive: true,
    defaultSelection: false,
    defaultProject: null,
    projects: []
})
